export const initialDriverForm = {
  name: "",
  cnic: "",
  contactNumber: "",
  image: "",
  status: "available",
  license: {
    number: "",
    expiryDate: "",
  },
  employment: {
    driverType: "ad_hoc",
    salaryType: "per_trip",
    salaryAmount: "",
  },
};

const cnicPattern = /^\d{5}-\d{7}-\d$/;

export const formatDriverDate = (dateValue) => {
  if (!dateValue) return "-";
  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) return "-";
  return date.toLocaleDateString();
};

export const formatDriverCurrency = (amount) => {
  if (typeof amount !== "number") return "-";
  return amount.toLocaleString();
};

export const normalizeDrivers = (data) => {
  if (Array.isArray(data)) return data;
  return data?.drivers || data?.items || [];
};

export const filterDrivers = (drivers, searchTerm) => {
  const term = searchTerm.trim().toLowerCase();
  if (!term) return drivers;

  return drivers.filter((driver) => {
    const name = driver?.name?.toLowerCase() || "";
    const cnic = driver?.cnic?.toLowerCase() || "";
    const contact = driver?.contactNumber?.toLowerCase() || "";
    const userId = driver?.userId?.toLowerCase() || "";
    const license = driver?.license?.number?.toLowerCase() || "";

    return (
      name.includes(term) ||
      cnic.includes(term) ||
      contact.includes(term) ||
      userId.includes(term) ||
      license.includes(term)
    );
  });
};

export const getSalaryLabel = (salaryType) => {
  if (salaryType === "per_day") return "Per Day Amount";
  if (salaryType === "per_trip") return "Per Trip Amount";
  if (salaryType === "per_month") return "Per Month Amount";
  return "Salary Amount";
};

export const formatDriverSalaryType = (salaryType) => {
  if (salaryType === "per_day") return "Per Day";
  if (salaryType === "per_trip") return "Per Trip";
  if (salaryType === "per_month") return "Per Month";
  return salaryType || "-";
};

export const mapDriverToForm = (driver) => ({
  name: driver?.name || "",
  cnic: driver?.cnic || "",
  contactNumber: driver?.contactNumber || "",
  image: driver?.image || "",
  status: driver?.status || "available",
  license: {
    number: driver?.license?.number || "",
    expiryDate: driver?.license?.expiryDate
      ? new Date(driver.license.expiryDate).toISOString().slice(0, 10)
      : "",
  },
  employment: {
    driverType: driver?.employment?.driverType || "ad_hoc",
    salaryType: driver?.employment?.salaryType || "per_trip",
    salaryAmount:
      typeof driver?.employment?.salaryAmount === "number"
        ? String(driver.employment.salaryAmount)
        : "",
  },
});

export const validateDriverForm = (form) => {
  const errors = {};

  if (!form.name.trim()) errors.name = "Name is required.";

  if (!form.cnic.trim()) {
    errors.cnic = "CNIC is required.";
  } else if (!cnicPattern.test(form.cnic.trim())) {
    errors.cnic = "Use CNIC format: 37405-1234567-1";
  }

  if (!form.contactNumber.trim()) errors.contactNumber = "Contact number is required.";
  if (!form.license.number.trim()) errors["license.number"] = "License number is required.";
  if (!form.license.expiryDate) errors["license.expiryDate"] = "License expiry date is required.";

  if (!form.employment.salaryAmount || Number(form.employment.salaryAmount) <= 0) {
    errors["employment.salaryAmount"] = "Enter a valid salary amount.";
  }

  return errors;
};

export const buildDriverPayload = (form) => ({
  name: form.name.trim(),
  cnic: form.cnic.trim(),
  contactNumber: form.contactNumber.trim(),
  image: form.image || "",
  status: form.status,
  license: {
    number: form.license.number.trim(),
    expiryDate: new Date(form.license.expiryDate).toISOString(),
  },
  employment: {
    driverType: form.employment.driverType,
    salaryType: form.employment.salaryType,
    salaryAmount: Number(form.employment.salaryAmount),
  },
});
